import { render } from "./App.vue?vue&type=template&id=595f9cd8&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=595f9cd8&lang=scss"

import exportComponent from "C:\\Users\\Utente\\Desktop\\JobFile\\Avvocato_IvanaNicolo\\AvvProject-Front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__